<template>
  <div fluid :class="windowWidth < 960 ? 'fondoMovil' : 'fondoPC'" :style="somePanelOpen ? 'height: 100%' : 'height: 100%;'">
    <v-container fluid>
      <v-row class="mb-n6">
        <v-col v-if="windowWidth < 960" md="6" class="d-flex justify-center align-self-start"> </v-col>
        <v-col :md="windowWidth >= 960 && windowWidth <= 1250 ? '7' : '6'"></v-col>
        <v-col cols="12" :md="windowWidth >= 960 && windowWidth <= 1250 ? '5' : '6'">
          <h1 class="fMontserrat font-weight-bold mb-n2" :style="getStyleCongrats()">
            {{ t("enhorabuena") }}
          </h1>
          <h2 class="fMontserrat text-bold mb-8">
            {{ t("texto1") }}
          </h2>
          <p class="fMontserrat font-weight-medium mb-5">
            {{ t("texto2") }}
          </p>

          <RecursiveExpansionPanel :panels="panels" />
          <p class="fMontserrat mt-5 mb-5">
            {{ t("texto3") }}
          </p>
        </v-col>
      </v-row>
    </v-container>
    <!-- PC -->

    <FooterComponent v-if="windowWidth >= 960" />
    <v-overlay :model-value="overlay" class="align-center justify-center">
      <v-progress-circular color="primary" size="64" indeterminate />
    </v-overlay>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, computed } from "vue";
import { t } from "../functions/translation.js";
import RecursiveExpansionPanel from "../components/RecursiveExpansionPanel.vue";
import FooterComponent from "../components/FooterComponent.vue";

var panels = ref([]);
var overlay = ref(false);

var windowWidth = ref(window.innerWidth);

const handleResize = () => {
  windowWidth.value = window.innerWidth;
};

onMounted(() => {
  window.addEventListener("resize", handleResize);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", handleResize);
});

const somePanelOpen = computed(() => {
  return panels.value.some((panel) => panel.open);
});

const getStyleCongrats = () => {
  return windowWidth.value > 1070 ? "font-size: 60px;" : windowWidth.value > 400 ? "font-size: 50px;" : "";
};

var idioma = localStorage.getItem("locale");
idioma = idioma == null ? "es" : idioma.substring(0, 2);
var imagenSol = `sol_${idioma.toUpperCase()}.png`;
console.log(`/images/${imagenSol}`);
panels.value = [
  {
    id: 1,
    title: `1. ${t("titulo1Optico")}`,
    content: t("texto1Optico"),
    color: "#088E4B",
    subColor: "#D3D1D3",
    open: false,
    videos: [
      {
        id: 1,
        cols: 12,
        src: `/videos/INDO.mp4`,
      },
    ],
    images: [
      { id: 1, cols: 6, src: require("@/assets/GafasExpuestas.png") },
      { id: 2, cols: 6, src: require("@/assets/GafasGamuza.png") },
    ],
    content2: t("texto12OpticoNew"),
  },
  {
    id: 2,
    title: `2. ${t("titulo2Optico")}`,
    content: "",
    color: "#088E4B",
    subColor: "#D3D1D3",
    open: false,
    images: [{ id: 1, cols: 12, src: `/images/${imagenSol}`, maxwidth: "600px" }],
  },
];
</script>

<style>
.movedIcon {
  position: absolute;
  top: 0px;
  left: 0px;
}

.fMontserrat {
  font-family: Montserrat;
}

.rounded-panel {
  border-radius: 20px !important;
}

.rounded-panelText {
  border-radius: 0% 0% 20px 20px;
}

.cursorPointer {
  cursor: pointer;
}
.fondo {
  position: relative;
  z-index: 0;
  width: 100%;
  height: 100%;
}
.fondoPC {
  background-image: url("/public/images/Fondo3.png");
  background-repeat: no-repeat;
  background-size: 1400px auto;
  background-color: darkgray;
  background-position: top;
}
.fondoMovil {
  background: radial-gradient(#e1dede, #625f5f8c);
}
.imgShadow {
  filter: drop-shadow(0 0 0.25rem #282424);
}
</style>
